import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerManagerParams, TypePostOwnerManagerResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 담당자 정보 등록
 */
const usePostOwnerManager = () => {
  const endPoint = '/api-owner/owner-manager';

  const postOwnerManager = async (params: TypePostOwnerManagerParams) => {
    return axiosInstance
      .post<TypePostOwnerManagerResponse>(endPoint, {
        ...params,
      })
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOwnerManager };
};

export default usePostOwnerManager;
